import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Autocomplete } from "@/components/Autocomplete";

export const PicsEditor = ({ pics, onChange, picOpts }) => {
  const upd = (i, patch) => onChange(pics.map((p, idx) => (idx === i ? { ...p, ...patch } : p)));
  return (
    <div className="space-y-2" data-testid="pics-editor">
      {pics.map((p, i) => (
        <div key={i} className="grid grid-cols-[1.3fr_1fr_1fr_auto] gap-2" data-testid={`pic-row-${i}`}>
          <Autocomplete value={p.name} testId={`activity-pic-name-${i}`} placeholder={`Nama PIC ${i + 1}`} options={picOpts} onChange={(v) => upd(i, { name: v })} />
          <Input className="bg-white" placeholder="Jabatan" value={p.position} onChange={(e) => upd(i, { position: e.target.value })} data-testid={`activity-pic-position-${i}`} />
          <Input className="bg-white" placeholder="No. HP" value={p.phone} onChange={(e) => upd(i, { phone: e.target.value })} data-testid={`activity-pic-phone-${i}`} />
          <Button size="icon" variant="ghost" disabled={pics.length === 1} onClick={() => onChange(pics.filter((_, idx) => idx !== i))} data-testid={`activity-pic-remove-${i}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" className="bg-white" onClick={() => onChange([...pics, { name: "", position: "", phone: "" }])} data-testid="activity-add-pic-btn"><Plus className="h-4 w-4 mr-1" />Tambah PIC</Button>
    </div>
  );
};
